<template>
  <div class="links">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Review and feedback Links</span>
      </heading-wrap>

      <spinner v-if="loading" />

      <table-links-review-comments :showModalHandler="showModalHandler" :cloneReviewHandler="cloneReviewHandler"/>
      <table-links-quick-preview :showModalHandler="showModalHandler" />
    </div>

    <portal to="globalModal">
      <modal-link-confirm
          :show="showModal.deleteLink"
          :type="modalType"
          :confirmId="modalId"
          :linkType="modalFieldType"
          @close="toggleModal('deleteLink')"/>
      <modal-edit-link
          v-if="showModal.editLink"
          :show="showModal.editLink"
          :type="modalType"
          :confirmId="modalId"
          :field="modalField"
          :oldPassword="oldPassword"
          :linkType="modalFieldType"
          :allowEditPassword="allowEditPassword"
          @close="toggleModal('editLink')"/>
      <modal-refresh-link
          :show="showModal.refreshLink"
          :type="modalType"
          :confirmId="modalId"
          :linkType="modalFieldType"
          @close="toggleModal('refreshLink')"/>
      <modal-create-preview-link
          v-if="showModal.createPreviewLink"
          :creativeData="creativeData"
          :selectedUnitsIds="selectedUnitsIds"
          :show="showModal.createPreviewLink"
          :type="modalType"
          :confirmId="modalId"
          :isClone="true"
          :currentLinkName="modalField"
          @actionChange="cloneReviewAction"
          @close="toggleModal('createPreviewLink')" />
      <modal-preview-link
          v-if="showModal.previewLink"
          :show="showModal.previewLink"
          :type="modalType"
          :confirmId="modalId"
          :responseData="modalData"
          @close="closePreviewLinkModal" />
    </portal>

  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'

import {linkMixin, LINKS_TABLE_TYPES} from '@/mixins/linkMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import TableLinksReviewComments from '@/components/LinksReviewComments/table-links-review-comments'

import TableLinksQuickPreview from '@/components/LinksReviewComments/table-links-quick-preview'
import Modal from '@/components/Modal/modal'
import {modalMixin} from '@/mixins/modalMixin'

import ModalRefreshLink from '@/components/Modal/links/modal-refresh-link'
import ModalEditLink from '@/components/Modal/links/modal-edit-link'
import ModalLinkConfirm from '@/components/Modal/links/modal-link-confirm'

import ModalCreatePreviewLink from '@/components/Modal/creatives/modal-create-preview-link'
import ModalPreviewLink from '@/components/Modal/creatives/modal-preview-link'
import {creativeMixin} from '@/mixins/creativeMixin'

export default {
  name: 'Links',
  mixins: [linkMixin, modalMixin, notificationMixin, creativeMixin],
  components: {
    HeadingWrap,
    Spinner,
    SearchBox,
    TableLinksReviewComments,
    TableLinksQuickPreview,
    Modal,
    ModalRefreshLink,
    ModalEditLink,
    ModalLinkConfirm,
    ModalCreatePreviewLink,
    ModalPreviewLink
  },
  props: {
    tableData: Array
  },
  data: () => ({
    search: '',
    selectedUnitsIds: [],
    creativeData: {},
    allowEditPassword: false,
    oldPassword: ''
  }),
  mounted () {
  },
  computed: {
  },
  methods: {
    showModalHandler (event) {
      this.oldPassword = event.currentTarget.dataset.oldpassword ? event.currentTarget.dataset.oldpassword : null
      this.allowEditPassword = event.currentTarget.dataset.modalfieldtype === 'review-and-comments'
      this.onLaunchModal(event)
    },
    cloneReviewAction (data) {
      this.startLoading()
      this.updateBulkCreative(data.currentTarget.dataset).then(response => {
        this.selectedUnitsIds = []
        this.creativeData = {}
        if (response.preview_url) {
          this.modalData = response
          this.showModal['previewLink'] = true
          this.finishLoading()
        }
      })
    },
    closePreviewLinkModal () {
      this.toggleModal('previewLink')
      this.startLoading()
      this.getLinks(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS).then(() => {
        this.finishLoading()
      })
    },
    cloneReviewHandler (evt) {
      this.startLoading()
      const dataset = evt.currentTarget.dataset
      this.validateReviewClone(evt.currentTarget.dataset.hashid).then(({data}) => {
        this.finishLoading()
        this.selectedUnitsIds = []
        if (data.units_fail.length > 0) {
          let unitsFailed = ''
          data.units_fail.forEach((item, i) => {
            unitsFailed += ` \n  -> ${item.locale}: ${item.master} | ${item.width}x${item.height} `
          })
          const notification = this.addNotification('danger', `Please make sure that all the units related with this review link are in state rendered: ${unitsFailed}`)
          setTimeout(() => {
            this.closeLastNotification(notification.id)
          }, 15000) // Wait 15 second to remove the notification
          return false
        }
        data.units_success.forEach((item) => {
          this.selectedUnitsIds.push(item.id)
        })
        data.creative.units = data.units_success
        this.creativeData['data'] = {creative: data.creative, units: data.units_success}
        this.onLaunchModal({currentTarget: {dataset}})
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/links.vue